import { links } from '../config';

export type StorePlatform = 'ios' | 'android' | 'other';

export type StoreBadgeKind = 'ios' | 'android';

/** Detect mobile store platform from UA (client-only; safe defaults for SSR). */
export function detectStorePlatform(ua = '', maxTouchPoints = 0, platform = ''): StorePlatform {
  if (/android/i.test(ua)) return 'android';
  if (/iPhone|iPad|iPod/i.test(ua)) return 'ios';
  // iPadOS 13+ may report as Mac
  if (platform === 'MacIntel' && maxTouchPoints > 1) return 'ios';
  return 'other';
}

export function detectStorePlatformFromNavigator(): StorePlatform {
  if (typeof navigator === 'undefined') return 'other';
  return detectStorePlatform(navigator.userAgent, navigator.maxTouchPoints, navigator.platform);
}

/** Both store badges in the final CTA (links fall back to #download when a URL is unset). */
export function displayStoreBadges(): readonly [StoreBadgeKind, StoreBadgeKind] {
  return ['ios', 'android'];
}

/** Direct store URL for mobile nav / hero when platform is known. */
export function primaryStoreUrl(platform: StorePlatform): string | null {
  if (platform === 'ios') {
    const url = links.ios.trim();
    return url || null;
  }
  if (platform === 'android') {
    const url = links.android.trim();
    return url || null;
  }
  return null;
}

export function hrefForStoreBadge(kind: StoreBadgeKind, fallbackAnchor: string): string {
  if (kind === 'ios') {
    return links.ios.trim() || fallbackAnchor;
  }
  return links.android.trim() || fallbackAnchor;
}

export function isExternalStoreUrl(href: string): boolean {
  return href.startsWith('http://') || href.startsWith('https://');
}
